import React, { useEffect, useState, useCallback } from 'react';
import { Box, Button, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Para redirigir al formulario de nueva receta
import { ApiRequest } from '../../services/api'; // Ajusta la ruta según tu estructura
import CustomTableRow from './CustomTableRow';

function IngredientList() {
  const [recipes, setRecipes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate(); // Hook para la navegación

  const loadRecipes = useCallback(async () => {
      try {
        const data = await ApiRequest("api/Ingrediente/ListarIngredientes");
        const sortedData = [...(data || [])].sort((a, b) =>
          a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
        );
        setRecipes(sortedData);
      } catch (error) {
        console.error("Error fetching ingredientes:", error);
      }
    }, []);
    
    useEffect(() => {
      loadRecipes();
    }, [loadRecipes]);

  // Función para normalizar texto de búsqueda
  const normalizeText = (text) => 
    text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  // Filtrar recetas
  const filteredRecipes = recipes.filter(recipe => 
    normalizeText(recipe.nombre).includes(normalizeText(searchTerm))
  );

  // Función para redirigir al formulario de creación de receta
  const handleAddNew = () => {
    navigate('/Dashboard/Ingredientes/New'); // Ajusta la ruta al formulario de nueva receta
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Ingredientes
      </Typography>


      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        gap: 2
      }}>
        <TextField
          label="Buscar ingrediente"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ flex: 1, maxWidth: 400 }}
        />

        <Button variant="contained" color="primary" onClick={handleAddNew}>
          Nuevo
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        overflow: 'hidden'
      }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Marca</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRecipes.map((ingredient, index) => (
              <CustomTableRow key={index} item={ingredient} onDeleteSuccess={loadRecipes} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Mensaje cuando no hay resultados */}
      {
        filteredRecipes.length === 0 && (
          <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
            No se encontraron ingredientes
          </Typography>
        )
      }
    </Box >
  );
}

export default IngredientList;
